// Lib
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { get } from 'lodash/fp';

// Actions
import { handlePermissionTokenResponse } from '../../utils/permissions/permissionsActions';

// Constants
import { APP_QUERY_PARAMS } from '../../../common/utils/urlConstants';

const getUrlPermissionToken = get(['query', APP_QUERY_PARAMS.PERMISSION_TOKENS]);

const mapDispatchToProps = (dispatch) => ({
    dispatchSetPermissionToken: (token) => dispatch(handlePermissionTokenResponse({ token })),
});

/**
 * This component allows a permission token to be included on the URL.
 * If it exists it will be decoded and converted into permissions to be used locally.
 */
const UrlPermissionTokenSynchroniser = (props) => {
    React.useEffect(() => {
        const permissionToken = getUrlPermissionToken(props.location);
        if (permissionToken) props.dispatchSetPermissionToken(permissionToken);
    }, []);

    return null;
};

UrlPermissionTokenSynchroniser.propTypes = {
    location: PropTypes.object,
    dispatchSetPermissionToken: PropTypes.func,
};

export default connect(null, mapDispatchToProps)(UrlPermissionTokenSynchroniser);
